import BricksOnSaleSummaryError from './BricksOnSaleSummaryError';
class OnSaleInvalidPropertyId extends BricksOnSaleSummaryError {
    propertyId;
    constructor(propertyId, options) {
        super('On sale property id is invalid', options);
        this.propertyId = propertyId;
    }
}
export default OnSaleInvalidPropertyId;
